import { render } from "./SampleEvaluationForm.vue?vue&type=template&id=2a28db07"
import script from "./SampleEvaluationForm.vue?vue&type=script&lang=js"
export * from "./SampleEvaluationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__